import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchEmployeeStatusList = createAsyncThunk("fetchEmployeeStatusList", async () => {
    try {
        const response = await axiosHttp.get(`status/list?identifier=approval_request`);
        return response.data.data;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
});

const EmployeeStatusListSlice = createSlice({
    name: "EmployeeStatusListSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null
    },

    extraReducers: (builder) => {
        builder.addCase(fetchEmployeeStatusList.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchEmployeeStatusList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchEmployeeStatusList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default EmployeeStatusListSlice.reducer;
